<script setup>
import { computed } from 'vue';

const props = defineProps({
  barcodes: {
    type: Object,
    default: () => ({ real: 0, auto: 0, missing: 0 }),
  },
});

const total = computed(() => props.barcodes.real + props.barcodes.auto + props.barcodes.missing);
</script>

<template>
  <div v-if="total === 0" class="tw:text-xs tw:text-zinc-400">
    {{ $t('No item in an event park') }}
  </div>
  <div v-else class="tw:flex tw:flex-wrap tw:items-center tw:gap-x-3 tw:gap-y-1">
    <span class="tw:shrink-0 tw:text-[10px] tw:font-semibold tw:uppercase tw:tracking-wide tw:text-zinc-400">
      {{ $t('Barcodes') }}
    </span>
    <span class="tw:flex tw:h-1.5 tw:w-32 tw:shrink-0 tw:overflow-hidden tw:rounded-full tw:bg-zinc-100">
      <span v-if="barcodes.real" class="tw:bg-green-500" :style="{ flexGrow: barcodes.real }"></span>
      <span v-if="barcodes.auto" class="tw:bg-amber-500" :style="{ flexGrow: barcodes.auto }"></span>
      <span v-if="barcodes.missing" class="tw:bg-red-500" :style="{ flexGrow: barcodes.missing }"></span>
    </span>
    <span class="tw:flex tw:flex-wrap tw:gap-x-3 tw:text-xs tw:tabular-nums">
      <span :class="barcodes.real ? 'tw:text-green-600' : 'tw:text-zinc-400'">
        <b class="tw:font-semibold">{{ barcodes.real }}</b> {{ $t('real') }}
      </span>
      <span :class="barcodes.auto ? 'tw:text-amber-600' : 'tw:text-zinc-400'">
        <b class="tw:font-semibold">{{ barcodes.auto }}</b> {{ $t('auto') }}
      </span>
      <span :class="barcodes.missing ? 'tw:text-red-600' : 'tw:text-zinc-400'">
        <b class="tw:font-semibold">{{ barcodes.missing }}</b> {{ $t('without') }}
      </span>
    </span>
  </div>
</template>
